import { Component } from '@theme/component';

/**
 * Status lookup card. The results app redirects failed lookups back with
 * `?status_lookup=<reason>`; this shows the matching message and drops the
 * parameter so a reload doesn't repeat it.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement[]} [messages]
 *
 * @extends {Component<Refs>}
 */
class KsStatusLookup extends Component {
  connectedCallback() {
    super.connectedCallback();

    const url = new URL(window.location.href);
    const reason = url.searchParams.get('status_lookup');
    if (!reason) return;

    const message = (this.refs.messages ?? []).find((m) => m.dataset.reason === reason);
    if (message) message.hidden = false;
    window.phCapture?.('kundenservice_status_lookup_failed', { reason });

    url.searchParams.delete('status_lookup');
    window.history.replaceState(window.history.state, '', url);
  }
}

if (!customElements.get('ks-status-lookup')) {
  customElements.define('ks-status-lookup', KsStatusLookup);
}
